<app-demo [datasource]="datasource" [context]="demoContext" [sources]="sources">
  <div description>
    <p>
      Horizontal scrolling could be enabled via <em>horizontal</em> setting. The
      styles also need to be fixed in accordance with horizontal scrolling.
      Currently we have some limitations at the template layer but
      <em>display: inline-block;</em> rule applied to all nested containers
      makes the horizontal mode work.
    </p>
  </div>
</app-demo>
